import { Modal, SystemText, Table } from '@salesperformanceint/e4shared';
import { skillColour } from 'helpers/metrics';
import { translateSkill } from 'helpers/translations';
import React from 'react';
import { useSelector } from 'react-redux';

export const Skills = ({ show, close, hideBehaviour }) => {
    const [behaviour, setBehaviour] = React.useState('-');
    const [quizResults, setQuizResults] = React.useState([]);
    const [quizSortBy, setQuizSortBy] = React.useState('score');
    const [quizDescending, setQuizDescending] = React.useState(true);

    const [examResults, setExamResults] = React.useState([]);

    const user = useSelector(state => state.user.user);

    const isPrism = user?.companySettings?.prism_UI;

    React.useEffect(() => {
        if (show?.skills) {
            const d = quizDescending ? -1 : 1;

            setQuizResults(
                JSON.parse(show.skills)
                    .map(s => translateSkill(user.language_Code, s))
                    .map(s => ({
                        skill: s.title,
                        score: s.score,
                    }))
                    .sort((a, b) => (a[quizSortBy] > b[quizSortBy] ? 1 * d : -1 * d))
            );
        } else {
            setQuizResults([]);
        }

        if (show?.examResults) {
            setExamResults(show.examResults.map(s => translateSkill(user.language_Code, s)));
        } else {
            setExamResults([]);
        }

        if (!isPrism && !hideBehaviour) {
            if (show?.competency_Names?.length) {
                setBehaviour(show.competency_Names[0]);
            } else {
                setBehaviour('-');
            }
        }
    }, [show]);

    React.useEffect(() => {
        const d = quizDescending ? -1 : 1;
        setQuizResults(quizResults.sort((a, b) => (a[quizSortBy] > b[quizSortBy] ? 1 * d : -1 * d)));
    }, [quizSortBy, quizDescending]);

    let examColumns = [
        {
            label: SystemText('LearningTracker/Skills/Table/AssessmentResults'),
            className: 'prism-test-result',
            dataProperty: 'title',
        },
        {
            label: 'First Attempt',
            dataProperty: 'firstScore',
            className: 'text-center prism-test-result',
            format: x => <label className={`label label-light-${skillColour(x)}`}>{parseInt(x, 10)}%</label>,
        },
        {
            label: 'Latest Attempt',
            dataProperty: 'latestScore',
            className: 'text-center prism-test-result',
            format: x => <label className={`label label-light-${skillColour(x)}`}>{parseInt(x, 10)}%</label>,
        },
    ];

    const examOptions = {
        hidePaging: true,
        tableClass: 'table table-striped',
    };

    let quizResultColumns = [
        {
            label: SystemText('LearningTracker/Skills/Table/Behavior'),
            dataProperty: 'behaviour',
            format: () => <span>{behaviour}</span>,
        },
        {
            label: isPrism
                ? SystemText('LearningTracker/Skills/Table/Skill/Prism')
                : SystemText('LearningTracker/Skills/Table/Skill'),
            className: 'prism-test-result',
            dataProperty: 'skill',
        },
        {
            label: isPrism ? null : SystemText('LearningTracker/Skills/Table/Score'),
            dataProperty: 'score',
            className: 'text-center prism-test-result',
            format: x => <label className={`label label-light-${skillColour(x)}`}>{parseInt(x, 10)}%</label>,
        },
    ];

    if (hideBehaviour) {
        quizResultColumns = quizResultColumns.filter(x => x.dataProperty !== 'behaviour');
        examColumns = examColumns.filter(x => x.dataProperty !== 'behaviour');
    }

    const quizOptions = {
        hidePaging: true,
        tableClass: 'table table-striped',
        sortBy: isPrism ? null : quizSortBy,
        ascending: isPrism ? null : !quizDescending,
    };

    const quizTriggerSort = React.useCallback(
        column => {
            column === quizSortBy && setQuizDescending(!quizDescending);
            setQuizSortBy(column);
        },
        [quizSortBy, quizDescending]
    );

    return (
        <Modal show={show} title={show.title} close={close} footer={null}>
            {examResults?.length > 0 && <Table data={examResults} columns={examColumns} options={examOptions} />}
            <Table data={quizResults} columns={quizResultColumns} options={quizOptions} sort={quizTriggerSort} />
        </Modal>
    );
};

export default Skills;
